import React from "react";
const Logged=React.createContext(false);

export default Logged;